import React from 'react';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { message, notification } from 'antd';
import { useNavigate } from 'react-router-dom';

const Account = () => {
    const navigate = useNavigate();

    // Yup Validation Schema
    const validationSchema = Yup.object({
        email_or_phone: Yup.string()
            .required('This field is required')
            .test('is-valid', 'Must be a valid email or phone number', (value) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const phoneRegex = /^\d{10,15}$/;
                return emailRegex.test(value) || phoneRegex.test(value);
            }),
        password: Yup.string().required('Password is required'),
    });

    // Formik Hook
    const formik = useFormik({
        initialValues: {
            email_or_phone: '',
            password: '',
            type: '', // 'email' or 'phone' based on input
        },
        validationSchema,
        onSubmit: (values) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const type = emailRegex.test(values.email_or_phone) ? 'email' : 'phone';
            values.type = type;

            axios
                .post(`${process.env.REACT_APP_BACKEND_URI}/auth/login`, values)
                .then((response) => {
                    localStorage.setItem('accessToken', response.data.token);
                    message.success('Logged In Successfully');
                    navigate('/profile-page');
                })
                .catch((error) => {
                    // Use Ant Design notification for error messages
                    notification.error({
                        message: 'Incorrect Credentials',
                        description: 'Incorrect credentials, please try again.',
                        placement: 'topRight',
                    });
                });
        },
    });

    return (
        <section className="account py-40 px-120">
            <div className="container container-lg">
                <form onSubmit={formik.handleSubmit}>
                    <div className="row gy-4">
                        <div className="col-xl-12 px-130">
                            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
                                <h6 className="text-xl mb-32">Login</h6>
                                <div className="mb-24">
                                    <label
                                        htmlFor="email_or_phone"
                                        className="text-neutral-900 text-lg mb-8 fw-medium"
                                    >
                                        Phone Number or Email Address <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`common-input ${
                                            formik.touched.email_or_phone && formik.errors.email_or_phone
                                                ? 'is-invalid'
                                                : ''
                                        }`}
                                        id="email_or_phone"
                                        placeholder="Enter phone number or email"
                                        {...formik.getFieldProps('email_or_phone')}
                                    />
                                    {formik.touched.email_or_phone && formik.errors.email_or_phone && (
                                        <div className="text-danger">
                                            {formik.errors.email_or_phone}
                                        </div>
                                    )}
                                </div>
                                <div className="mb-24">
                                    <label
                                        htmlFor="password"
                                        className="text-neutral-900 text-lg mb-8 fw-medium"
                                    >
                                        Password
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type="password"
                                            className={`common-input ${
                                                formik.touched.password && formik.errors.password
                                                    ? 'is-invalid'
                                                    : ''
                                            }`}
                                            id="password"
                                            placeholder="Enter Password"
                                            {...formik.getFieldProps('password')}
                                        />
                                        {formik.touched.password && formik.errors.password && (
                                            <div className="text-danger">{formik.errors.password}</div>
                                        )}
                                        <span
                                            className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ph-eye-slash"
                                            id="#password"
                                        />
                                    </div>
                                </div>
                                <div className="mb-24 mt-48">
                                    <div className="flex-align gap-48 flex-wrap">
                                        <button type="submit" className="btn btn-main py-18 px-40">
                                            Log in
                                        </button>
                                        <div className="form-check common-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="remember"
                                            />
                                            <label
                                                className="form-check-label flex-grow-1"
                                                htmlFor="remember"
                                            >
                                                Remember me
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-48">
                                    <Link
                                        to="/change-password"
                                        className="text-danger-600 text-sm fw-semibold hover-text-decoration-underline"
                                    >
                                        Forgot your password?
                                    </Link>
                                </div>
                                <div className="mt-48">
                                    <Link
                                        to="/registration"
                                        className="text-danger-600 text-sm fw-semibold hover-text-decoration-underline"
                                    >
                                        Register Here
                                    </Link>
                                </div>

                                 
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default Account;
